import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #ffffff;
  padding: 32px 24px 32px;
  border-radius: 8px;
  -webkit-box-shadow: 0px 8px 20px 0px #0000000f;
  box-shadow: 0px 8px 20px 0px #0000000f;

  & + & {
    margin-top: 16px;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    background-color: #ebf1f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 40px;
    }
  }

  img {
    display: inline-block;
    width: 48px;
    height: 48px;
  }

  .product-name {
    font-size: 16px;
    font-weight: 500;
    color: #555658;
  }

  .product-description {
    font-size: 14px;
    font-weight: 500;
    color: #898b8e;
  }
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  margin-top: 9px;

  img {
    display: inline-block;
    width: 24px;
    height: 24px;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: #555658;
  }

  span {
    font-size: 14px;
    line-height: 22px;
    color: #898b8e;
    font-weight: 400;
  }
`;

export const Description = styled.div`
  font-weight: 400;
  color: #898b8e;
  font-size: 14px;
  line-height: 22px;
  display: block;
  margin-left: 32px;
`;
